import PropTypes from 'prop-types';
import './SuccessPage.css';

export default function SuccessPage({ result = null, onDone }) {
  const ticket = result?.ticketName
    ? result.ticketName
    : result?.ticketId
      ? `#HD-${String(result.ticketId).padStart(5, '0')}`
      : null;
  const isFb = result?.type === 'feedback';
  const alreadySubmitted = Boolean(result?.alreadySubmitted);

  return (
    <div className="sp">
      <div className="sp-body">
        <div className="sp-outer"><div className="sp-inner" aria-hidden>✓</div></div>
        <h1 className="sp-t">{alreadySubmitted ? 'Already Submitted' : 'Submitted!'}</h1>
        <p className="sp-s">
          {alreadySubmitted
            ? "You've already submitted feedback for this booking. Here is your reference."
            : (isFb ? 'Your feedback has been recorded and sent to our team.' : 'Your incident has been reported. Our team will follow up shortly.')}
        </p>
        {ticket && (
          <div className="sp-ref">
            <p className="sp-rl">Ticket Reference</p>
            <p className="sp-rv">{ticket}</p>
          </div>
        )}
        <button type="button" className="sp-btn" onClick={onDone}>🏠 Back to Home</button>
      </div>
    </div>
  );
}

SuccessPage.propTypes = {
  result: PropTypes.shape({
    ticketId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ticketName: PropTypes.string,
    type: PropTypes.oneOf(['feedback', 'incident']),
    alreadySubmitted: PropTypes.bool,
  }),
  onDone: PropTypes.func.isRequired,
};
